export default "https://cdn-static.gokick.com/assets/96917af4b324ebd1ae50a0309f8a33967fe87b4d/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";